var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{attrs:{"id":"account-banner"}},[_c('img',{attrs:{"src":require("../../assets/img/Hero-banner.png"),"alt":""}})]),_c('div',{staticClass:"container mt-4"},[_c('h1',[_vm._v("Page Not Found")]),_c('div',{staticClass:"ui warning message"},[_c('div',{staticClass:"header"},[_vm._v("Sorry the page you are looking for was not found.")])])])])
}]

export { render, staticRenderFns }